import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Modal
} from "react-bootstrap";
import { useState, useEffect } from "react";
import MaskedInput from 'react-text-mask';
import styles from "./UserProfilePageComponent.module.css";

const UserProfilePageComponent = ({
  updateUserApiRequest,
  fetchUser,
  getdeliveryBooks,
  userInfoFromRedux,
  setReduxUserState,
  reduxDispatch,
  localStorage,
  sessionStorage,
  getAllUniformRole
}) => {
  const [validated, setValidated] = useState(false);
  const [updateUserResponseState, setUpdateUserResponseState] = useState({
    success: "",
    error: "",
  });
  const [user, setUser] = useState({});
  const userInfo = userInfoFromRedux;
  const [deliveryBooks, setDeliveryBooks] = useState();
  const [selectedSite, setSelectedSite] = useState(null);
  const [abnNum, setAbnNum] = useState("");
  const abnMask = [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/];
  const [allUniformRoles, setAllUniformRoles] = useState([])
  const [userRole, setUserRole] = useState();
  const [otherRole, setOtherRole] = useState();
  const [showWelcome, setShowWelcome] = useState(false);

  const handleOtherRole = (e) => {
    setOtherRole(e.target.value);
  }

  const handleChangeRole = (e) => {
    setUserRole(e.target.value)
  }

  useEffect(() => {
    getAllUniformRole()
      .then((data) => {
        const updatedRoles = data.filter(role => role.role !== "other role");
        setAllUniformRoles(updatedRoles)
      })

      .catch((er) => console.log(er));
  }, []);

  useEffect(() => {
    fetchUser(userInfo._id)
      .then((data) => {
        setUser(data);
        setAbnNum(data.abn);
      })
      .catch((er) => console.log(er));

  }, [userInfo._id]);

  useEffect(() => {
    getdeliveryBooks()
      .then((deliveryBooks) => setDeliveryBooks(deliveryBooks))
      .catch((err) =>
        console.log(
          err.response.data.message
            ? err.response.data.message
            : err.response.data
        )
      );
  }, []);

  const deliverySites = deliveryBooks && deliveryBooks[0].sites;

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;
    const name = form.name.value;
    const lastName = form.lastName.value;
    const email = form.email.value;
    const phone = form.phone.value;
    const mobile = form.mobile.value;
    const location = selectedSite?.name;
    const company = form.company.value;
    // const role = userRole === "other role" ? otherRole : userRole;
    const role = form.role.value;
    const deliveryAddress = form.deliveryAddress.value;
    const state = form.state.value;
    const postCode = form.postCode.value;
    // const siteSku = form.siteSku.value;
    const abn = form.abn.value;

    if (event.currentTarget.checkValidity() === true) {
      updateUserApiRequest(
        name,
        lastName,
        email,
        phone,
        mobile,
        location,
        company,
        role,
        deliveryAddress,
        state,
        postCode,
        // siteSku,
        abn
      )
        .then((data) => {
          setUpdateUserResponseState({ success: data.success, error: "" });

          const updatedUserInfo = data.userUpdated;

          const currentUserInfo = JSON.parse(localStorage.getItem("userInfo"));

          const newUserInfo = {
            ...currentUserInfo,
            // siteSku: updatedUserInfo.siteSku,
            siteVerified: updatedUserInfo.siteVerified,
            location: updatedUserInfo.location,
          };

          localStorage.setItem("userInfo", JSON.stringify(newUserInfo));

          reduxDispatch(
            setReduxUserState({
              doNotLogout: userInfo.doNotLogout,
              ...data.userUpdated,
            })
          );
          if (userInfo.doNotLogout)
            localStorage.setItem(
              "userInfo",
              JSON.stringify({ doNotLogout: true, ...data.userUpdated })
            );
          else
            sessionStorage.setItem(
              "userInfo",
              JSON.stringify({ doNotLogout: false, ...data.userUpdated })
            );
        })
        .catch((er) =>
          setUpdateUserResponseState({
            error: er.response.data?.message
              ? er.response.data?.message
              : er.response.data,
          })
        );
    }

    setValidated(true);
  };


  const handleSiteChange = (e) => {
    const site = deliveryBooks[0].sites.find(
      (site) => site.id === e.target.value || site.name === e.target.value
    );
    setSelectedSite(site);
  };

  const handleAbn = (e) => {
    const newValue = e.target.value;
    setAbnNum(newValue);
  };

  const showWelcomeMessage = () => {
    setShowWelcome(true);
  }
  const hideWelcome = () => {
    setShowWelcome(false);
  };


  return (
    <>
      <Container className={styles.userProfilePageComponent}>
        <Row className="justify-content-md-center">
          <Col md={6} className="w-75">
            <h1>Change your profile</h1>

            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group className="mb-3" as={Col} md="6" controlId="validationCustom01">
                  <Form.Label>Your name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    defaultValue={user.name}
                    name="name"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a name
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" as={Col} md="6" controlId="formBasicLastName">
                  <Form.Label>Your last name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    defaultValue={user.lastName}
                    name="lastName"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter your last name
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" as={Col} md="6" controlId="formBasicEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    value={user.email}
                    disabled
                  />
                </Form.Group>

                <Form.Group className="mb-3" as={Col} md="6" controlId="formBasicAbn">
                  <Form.Label>ABN</Form.Label>
                  <MaskedInput
                    mask={abnMask}
                    placeholder="ABN"
                    guide={false}
                    value={abnNum}
                    onChange={handleAbn}
                    // id="abn"
                    render={(ref, props) => <Form.Control
                      required
                      minLength={14}
                      maxLength={14}
                      type="text"
                      name="abn"
                      // pattern="/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/,' ', /\d/, /\d/, /\d/"
                      ref={ref}
                      {...props}
                    />}
                  />
                </Form.Group>


              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="formBasicPhone">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Enter your phone number"
                    defaultValue={user.phone}
                  />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="formBasicMobile">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    required
                    type="tel"
                    name="mobile"
                    placeholder="Enter your mobile number"
                    defaultValue={user.mobile}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="formBasicLocation">
                  <Form.Label>Delivery Site:</Form.Label>
                  <Form.Select
                    required
                    name="location"
                    aria-label="Default select example"
                    onChange={handleSiteChange}
                  >
                    {deliverySites &&
                      deliverySites.map((site, idx) => {
                        return site.name !== "" ? (
                          user.location?.toLowerCase() ===
                            site.name?.toLowerCase() ? (
                            <option selected key={idx} value={site.name}>
                              {site.name}
                            </option>
                          ) : (
                            <option key={idx} value={site.name}>
                              {site.name}
                            </option>
                          )
                        ) : (
                          <option key={idx} value={site.name}>
                            {site.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="formBasicCompany">
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    type="text"
                    name="company"
                    disabled
                    value={user.company}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="formBasicRole">
                  <Form.Label>Role</Form.Label>
                  <Form.Control
                    type="text"
                    name="role"
                    placeholder="Role"
                    defaultValue={user.role}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {" "}
                    Please provide a valid Role.
                  </Form.Control.Feedback>
                </Form.Group>

              </Row>

              <Row className="mb-4" style={{ display: "none" }}>

                <Form.Group as={Col} md="5" controlId="formBasicdeliveryAddress">
                  <Form.Label>Delivery Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="deliveryAddress"
                    placeholder="Delivery Address"
                    defaultValue={user.deliveryAddress}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="formBasicPostCode">
                  <Form.Label>Postcode</Form.Label>
                  <Form.Control
                    type="text"
                    name="postCode"
                    placeholder="Postcode"
                    value={user.postCode}
                  />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="formBasicState">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    placeholder="State"
                    value={user.state}
                  />
                </Form.Group>
              </Row>

              {/* <Row>
                <Form.Group as={Col} md="6" controlId="formBasicRole">
                  <Form.Label>Role</Form.Label>
                  <Form.Select
                    required
                    name="role"
                    onChange={handleChangeRole}
                  >
                    <option >{user.role?.charAt(0).toUpperCase() + user.role?.slice(1).toLowerCase()}</option>
                    {
                      allUniformRoles.map((role, idx) => (
                        <option key={idx} value={role.role} style={{ textTransform: "capitalize" }}>
                          {role.role}
                        </option>))
                    }
                    <option key="other role">
                      Other Role
                    </option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please Select your Role.{" "}
                  </Form.Control.Feedback>
                </Form.Group>
                {userRole === "other role" && <Form.Group as={Col} md="6" controlId="formBasicOtherRole" className="mt-2">
                  <Form.Label></Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="otherRole"
                    placeholder="Job Title"
                    onChange={handleOtherRole}
                    value={otherRole}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please mention your Job Title.{" "}
                  </Form.Control.Feedback>
                </Form.Group>}
              </Row> */}

              <Row className="mt-4 ms-1 justify-content-md-left">
                <Button variant="primary" type="submit" className="w-auto">
                  Update
                </Button>
                <p></p>
                <Alert
                  show={
                    updateUserResponseState &&
                    updateUserResponseState.error !== ""
                  }
                  variant="danger"
                >
                  Something went wrong
                </Alert>
                <Alert
                  show={
                    updateUserResponseState &&
                    updateUserResponseState.success === "user updated"
                  }
                  variant="info"
                >
                  User updated
                </Alert>
                <span>*All disabled fields can only be updated by an Administrator</span>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
      <Modal
        show={showWelcome}
        onHide={hideWelcome}
        className="preview_message_modal"
      >
        <div className="p-6 bg-white shadow-md rounded-lg max-w-3xl mx-auto space-y-4">
          <h2 className="text-2xl font-bold text-blue-800">Welcome to CTL Australia – External Sales Team</h2>

          <p>Hi {userInfo?.name},</p>

          <p>
            We’re excited to have you onboard as the newest face of CTL Australia. Your role is one of the most
            important within our business: You will be the first handshake, the first conversation, and the first
            impression for hundreds of mining, drilling, and exploration businesses across Western Australia.
          </p>

          <h3 className="font-semibold text-lg mt-4">Your Mission:</h3>

          Introduce CTL Australia professionally and confidently.<br />
          Register new purchasing teams onto the CTL portal.<br />
          Promote our key capabilities: consumables, PPE, fast uniform turnaround with in-house embroidery, and full supply solutions.<br />
          Discover and report client pain points in their supply chain.<br />
          Support clients with simple, honest communication — and build genuine long-term partnerships.<br />


          <p className="mt-4">
            <strong>You will NOT be required to quote or price jobs.</strong><br />
            Instead, your success will be measured by relationships built, registrations secured, and accounts activated.
          </p>

          <p>
            <strong>Remember:</strong><br />
            You are not just selling products. You are selling time, trust, and support.
          </p>

          <p className="mt-6 font-semibold">Welcome to the CTL family. We’re backing you 100%.</p>
          <p className="text-right font-bold">– Josh Collins<br />Director, CTL Australia</p>
        </div>

      </Modal>
    </>
  );
};

export default UserProfilePageComponent;
